export default __webpack_public_path__ + "static/media/promo-text.9ab2330b.svg";